import React from 'react';

function Breadcrumbs({ className = '', items = [], label = 'Fil d Ariane' }) {
  const visibleItems = items.filter(Boolean);

  if (!visibleItems.length) {
    return null;
  }

  return (
    <nav className={['custom-breadcrumbs', className].filter(Boolean).join(' ')} aria-label={label}>
      <ol className="custom-breadcrumbs__list">
        {visibleItems.map((item, index) => {
          const isLast = index === visibleItems.length - 1;
          const content = item.onClick && !isLast ? (
            <button type="button" className="custom-breadcrumbs__link" onClick={item.onClick}>
              {item.label}
            </button>
          ) : (
            <span className="custom-breadcrumbs__current" aria-current={isLast ? 'page' : undefined}>
              {item.label}
            </span>
          );

          return (
            <li className="custom-breadcrumbs__item" key={`${item.label}-${index}`}>
              {content}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumbs;
